// issue #458: 稼働時間（昼）05:00〜22:00、（夜）22:01〜04:59。分単位の半開区間 [05:00, 22:00) を昼とする
const OPERATING_DAY_START_HOUR = 5;
const OPERATING_DAY_END_HOUR = 22;
const OPERATING_DAY_START_MINUTES = OPERATING_DAY_START_HOUR * 60;
const OPERATING_DAY_END_MINUTES = OPERATING_DAY_END_HOUR * 60;
const MSEC_PER_MINUTE = 60 * 1000;

// 業務開始〜業務終了を昼（05:00以上22:00未満）と夜に分けた分数を返す。どちらかが null か終了が開始以前なら両方 0
export const splitOperatingMinutesByDayNight = (
  start: Date | null, end: Date | null,
): { dayMinutes: number; nightMinutes: number } => {
  if (!start || !end) return { dayMinutes: 0, nightMinutes: 0 };

  // 業務開始・終了は5分単位に丸めて保存される
  const startMsec = truncateToMinute(start).getTime();
  const endMsec = truncateToMinute(end).getTime();
  if (endMsec <= startMsec) return { dayMinutes: 0, nightMinutes: 0 };

  const totalMinutes = (endMsec - startMsec) / MSEC_PER_MINUTE;
  let dayMinutes = 0;
  // 日付の境界・昼夜の境界をまたぐ区間も扱えるよう、境界ごとに区切って加算する
  let cursorMsec = startMsec;
  while (cursorMsec < endMsec) {
    const cursor = new Date(cursorMsec);
    const segmentEndMsec = Math.min(getNextDayNightBoundary(cursor).getTime(), endMsec);
    if (isDayTime(cursor)) {
      dayMinutes += (segmentEndMsec - cursorMsec) / MSEC_PER_MINUTE;
    }
    cursorMsec = segmentEndMsec;
  }

  const nightMinutes = totalMinutes - dayMinutes;
  return { dayMinutes, nightMinutes };
};

const truncateToMinute = (time: Date): Date => {
  const truncated = new Date(time.getTime());
  truncated.setSeconds(0, 0);
  return truncated;
};

const minutesOfDay = (time: Date): number => time.getHours() * 60 + time.getMinutes();

const isDayTime = (time: Date): boolean => {
  const minutes = minutesOfDay(time);
  return minutes >= OPERATING_DAY_START_MINUTES && minutes < OPERATING_DAY_END_MINUTES;
};

// time より後で最初に来る 05:00 または 22:00
const getNextDayNightBoundary = (time: Date): Date => {
  const minutes = minutesOfDay(time);
  const boundary = new Date(time.getTime());
  boundary.setSeconds(0, 0);
  if (minutes < OPERATING_DAY_START_MINUTES) {
    boundary.setHours(OPERATING_DAY_START_HOUR, 0);
    return boundary;
  }
  if (minutes < OPERATING_DAY_END_MINUTES) {
    boundary.setHours(OPERATING_DAY_END_HOUR, 0);
    return boundary;
  }
  boundary.setDate(boundary.getDate() + 1);
  boundary.setHours(OPERATING_DAY_START_HOUR, 0);
  return boundary;
};
